import DeleteIcon from "@mui/icons-material/Delete";
import { GridCellProps } from "@progress/kendo-react-grid";
import { useAppSelector } from "../../../../../app/hooks";
import { GridButton } from "../../../../../components";
import { useIncidentWitnessRemoveMutation } from "../../../../../services/varianceService/variance-api";
import { IncidentWitnessRemoveCommand } from "../../../../../services/varianceService/commands/WitnessRemoveCommand";

function WitnessDeleteBtn(props: GridCellProps) {
    
    const varianceId = useAppSelector(
        (state) => state.varianceRequest.varianceRequest.id
      );
  const [remove] = useIncidentWitnessRemoveMutation();
const handleRemove = () => {
    const command = new IncidentWitnessRemoveCommand(varianceId, props.dataItem.id);
    remove(command);
  };

  return (
    <GridButton
      color="error"
      startIcon={<DeleteIcon />}
      size="small"
      onClick={() => {
        handleRemove();
      }}
    >
      Delete
    </GridButton>
  );
}

export { WitnessDeleteBtn };
